// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3ZdbZ","signatureButtonsRight":"ModalSign_signatureButtonsRight__3Vfde"};